/**
 * Customer tags that are restricted and only visible to admin users.
 * These tags are filtered out for non-admin users when fetching customer tags configuration.
 */
export const RESTRICTED_CUSTOMER_TAGS = {
  ORDERING_BLOCK: 'ORDERING_BLOCK',
  ACCESS_APP_BLOCK: 'ACCESS_APP_BLOCK'
} as const;

export type RestrictedCustomerTag = typeof RESTRICTED_CUSTOMER_TAGS[keyof typeof RESTRICTED_CUSTOMER_TAGS]; 